import { http } from '@/api/Connect';
import { BASE_OPERATOR } from '@/api/CopyStake/BaseUrls';
import { AxiosResponse } from 'axios';

import {
  IStreamerFraudReportListParams,
  IStreamerFraudReportListResponse
} from '@/api/schema';

const API_STREAMER_FRAUD_REPORTS = {
  REPORTS_LIST(): string {
    return `${BASE_OPERATOR()}/streamer-report`; //GET
  },
  REPORTS_UNREAD_COUNT(): string {
    return `${BASE_OPERATOR()}/streamer-report/count-unread`; //GET
  },
  UPDATE_READ_STATUS(reportId: string | number): string {
    return `${BASE_OPERATOR()}/streamer-report/${reportId}/read`; //PUT
  }
};

export async function getStreamerFraudReportsList(
  params: IStreamerFraudReportListParams
): Promise<IStreamerFraudReportListResponse> {
  return http
    .get(API_STREAMER_FRAUD_REPORTS.REPORTS_LIST(), {
      params,
      cacheTime: 0,
      paramsSerializer: {
        indexes: null
      }
    })
    .then(({ data }: AxiosResponse<IStreamerFraudReportListResponse>) => data);
}

export async function getStreamerFraudReportsUnreadCount(): Promise<number> {
  return http
    .get(API_STREAMER_FRAUD_REPORTS.REPORTS_UNREAD_COUNT(), {
      cacheTime: 0
    })
    .then(({ data }: AxiosResponse<number>) => data);
}

export async function updateStreamerFraudReportReadStatus(
  reportId: number | string
): Promise<void> {
  return http
    .put(API_STREAMER_FRAUD_REPORTS.UPDATE_READ_STATUS(reportId))
    .then(({ data }: AxiosResponse): void => data);
}
